/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React, { Component } from "react";

// Infterface for component Props
interface HeaderOptionsPopupProps {
  open: boolean;
  // close: () => void;
  list: string[];
  handleOptionClick: () => void;
  handleOptionKeyPress: (event: any) => any
}

// Infterface for component State
interface HeaderOptionsPopupState {
}

/**
 * Why are we asking this popup component.
 *
 * @namespace HeaderOptionsPopup
 */

class HeaderOptionsPopup extends Component<
  HeaderOptionsPopupProps,
  HeaderOptionsPopupState
> {
  constructor(props: HeaderOptionsPopupProps) {
    super(props);
    this.state = {};
  }


  render() {
    const { open, list } = this.props;
    return (
      <div className={open ? "header-options" : "hide"}>
        {list && list.length > 0
          ? list.map((item, indexer) => (
            <div key={indexer}
              tabIndex={0}
              className="label"
              onClick={() => { this.props.handleOptionClick() }}
              onKeyPress={(e) => this.props.handleOptionKeyPress(e)}
            >
              {item}
            </div>
          ))
          : null}
      </div>
    );
  }
}

export default HeaderOptionsPopup;
